module.exports = __webpack_public_path__ + "img/embarrassing.2ac7ff77.gif";